"use client";

import React from "react";
import { Compass, User, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Administration",
  description: "Streamlined back-office support and organizational frameworks designed to optimize your internal workflows and ensure regulatory compliance across global markets.",
  icon: Compass
}, {
  title: "Project Management",
  description: "End-to-end oversight of complex initiatives. Our experts utilize precision scheduling and resource allocation to deliver large-scale projects on time and within budget.",
  icon: User
}, {
  title: "Logistics",
  description: "Sophisticated supply chain coordination and international transport management. We bridge geographical gaps to ensure seamless movement of assets and materials.",
  icon: Users
}];
export default function TherapeutischeSchwerpunkte() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222113" id="operational-excellence" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-screen-xl px-6 md:px-12">
        {}
        <h2 className="sr-only">Operational Excellence Services</h2>
        
        <div ref={ref} className={`grid grid-cols-1 gap-8 md:grid-cols-3 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          {services.map((service, i) => <Card key={i} data-index={i} className="group border-t-2 border-x-0 border-b-0 border-primary rounded-sm bg-white/5 backdrop-blur-md shadow-none transition-all duration-500 hover:-translate-y-2 hover:bg-white/10 hover:shadow-2xl hover:shadow-primary/20">
              <CardHeader className="p-0 mb-6 gap-0">
                <div className="mb-6 inline-flex">
                  <service.icon className="h-8 w-8 text-secondary transition-colors duration-500 group-hover:text-primary" strokeWidth={1} aria-hidden="true" />
                </div>
                <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground uppercase">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <p className="font-default text-base leading-relaxed text-secondary">
                  {service.description}
                </p>
                <div className="mt-6 opacity-0 -translate-x-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0">
                  <span className="text-primary text-sm font-mono">→ ACCESS MODULE</span>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}